// src/views/archive.ts
import type { ArchiveEntry } from '../types';
import { archiveDates } from '../core/date';
import { daysSinceEpoch } from '../core/puzzle';

type ArchiveOpts = {
  todayIso: string;
  archiveResults: Record<string, ArchiveEntry>;
  onPlay: (iso: string) => void;
  onBack: () => void;
};

function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${days[date.getUTCDay()]}, ${months[date.getUTCMonth()]} ${d}`;
}

export function renderArchiveList(root: HTMLElement, opts: ArchiveOpts): void {
  const dates = archiveDates(opts.todayIso);

  const cards = dates.map((iso) => {
    const dayNum = daysSinceEpoch(iso);
    const entry = opts.archiveResults[iso];
    const scoreLabel = entry ? `${entry.total}/100` : 'unplayed';
    const scoreClass = entry ? 'archive-card-score played' : 'archive-card-score';

    return `
      <button class="archive-card" type="button" data-iso="${iso}" aria-label="Play \u2116${dayNum}, ${formatDate(iso)}, ${scoreLabel}">
        <span class="archive-card-day">\u2116${dayNum}</span>
        <span class="archive-card-date">${formatDate(iso)}</span>
        <span class="${scoreClass}">${scoreLabel}</span>
      </button>
    `;
  }).join('');

  root.innerHTML = `
    <header class="app-header">
      <span class="brand">Barve</span>
      <span>Archive</span>
    </header>
    <div class="card">
      <p class="archive-subtitle">Replay the last 7 days. Scores count toward your profile but not your streak.</p>
      <div class="archive-list">
        ${cards}
      </div>
      <button class="secondary archive-back" id="archive-back" type="button">Back</button>
    </div>
  `;

  root.querySelectorAll<HTMLButtonElement>('.archive-card').forEach((btn) => {
    btn.addEventListener('click', () => {
      const iso = btn.dataset.iso!;
      opts.onPlay(iso);
    });
  });
  root.querySelector('#archive-back')!.addEventListener('click', opts.onBack);
}
